<template>
  <div>
    <v-row>
      <v-col>
        <h2 v-if="$route.params.id != undefined">{{ $t('investor_notices.edit_notices') }}</h2>
        <h2 v-else>{{ $t('investor_notices.new_notices') }}</h2>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-col xl="6" lg="6" md="6" sm="6" cols="12">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="select_publish_date" persistent width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="select_publish_date"
              :label="$t('investor_notices.publish_date')"
              :prepend-icon="calendar_icon"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="select_publish_date" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modal = false"> {{ $t('general.cancel') }} </v-btn>
            <v-btn text color="primary" @click="$refs.dialog.save(select_publish_date)">
              {{ $t('general.ok') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>

    <UploadFileTab
      v-on:getDocument="getUploadDocument"
      v-on:getDocumentName="getDocumentName"
      :document="notice_data.document"
      :document_title="notice_data.document_title"
    />

    <v-row>
      <v-col>
        <v-btn v-if="$route.params.id != undefined" color="success" depressed @click="updateNotices" :loading="loading">
          {{ $t('general.save') }}
        </v-btn>
        <v-btn v-else color="success" depressed @click="addNewNotices" :loading="loading">
          {{ $t('general.add') }}
        </v-btn>
      </v-col>
    </v-row>

    <SnackBar :text="snack_bar_text" :snackbar="snack_bar_open" v-on:close="updateSnackBar" />
  </div>
</template>

<script>
import { mdiCalendar } from '@mdi/js'
import { getData, postData } from '@/api'
import { globalFunc } from '@/global'
import Dialog from '@/components/Dialog'
import SnackBar from '@/components/SnackBar'
import UploadFileTab from '@/components/UploadFileTab.vue'

export default {
  name: 'InvestorRelationsNoticesDetail',
  mixins: [globalFunc],
  components: {
    UploadFileTab,
    Dialog,
    SnackBar,
  },
  data: () => ({
    notice_data: {
      publish_date: '',
      document_title: {
        zh: '',
        en: '',
        cn: '',
      },
      document: {
        zh: '',
        en: '',
        cn: '',
      },
      active: true,
    },
    check_notice_data: {
      publish_date: '',
      document_title: {
        zh: '',
        en: '',
        cn: '',
      },
      document: {
        zh: '',
        en: '',
        cn: '',
      },
      active: true,
    },
    select_publish_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substring(0, 10),
    check_select_publish_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substring(0, 10),
    snack_bar_text: '',
    snack_bar_open: false,
    modal: false,
    calendar_icon: mdiCalendar,
    loading: false,
  }),
  methods: {
    getDocumentName(name, type) {
      let lang = type.substring(type.lastIndexOf('.') + 1)
      this.notice_data.document_title[lang] = name
    },
    getUploadDocument(file, type) {
      if (file == null) {
        this.notice_data.document[type] = ''
      } else {
        this.notice_data.document[type] = file
      }
    },
    async initializeNotices() {
      if (!this.loading) {
        this.loading = true

        let error = true

        try {
          let params = new URLSearchParams()

          params.set(
            'get_single_data_by_data_type_and_id',
            JSON.stringify({
              id: this.$route.params.id,
              data_type: 'investor_relation_notices_data',
            }),
          )

          let result = await getData(params)

          if (globalFunc.DataValid(result)) {
            this.select_publish_date = result.publish_date

            Object.assign(this.notice_data, result)
            Object.assign(this.check_notice_data, result)

            error = false
          }
        } catch (error) {
          globalFunc.log(error)
        }

        if (error) {
          this.snack_bar_text = this.$t('instruction.data_not_found')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'InvestorRelationsNotices' })
          }, 2000)
        } else {
          this.loading = false
        }
      }
    },
    async addNewNotices() {
      if (!this.loading) {
        this.loading = true

        this.notice_data.publish_date = this.select_publish_date

        if (!globalFunc.DataValid(this.notice_data.document_title.zh)) {
          this.snack_bar_text =
            this.$t('error.force_input') +
            ' ' +
            this.$t('general.zh') +
            ' ' +
            this.$t('investor_notices.document_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.notice_data.document.zh)) {
          this.snack_bar_text =
            this.$t('error.force_upload') + ' ' + this.$t('general.zh') + ' ' + this.$t('general.document')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (
          globalFunc.DataValid(this.notice_data.document_title.en) &&
          !globalFunc.DataValid(this.notice_data.document.en)
        ) {
          this.snack_bar_text =
            this.$t('error.force_upload') + ' ' + this.$t('general.en') + ' ' + this.$t('general.document')
          this.loading = false
          this.snack_bar_open = true
          return
        }

        if (
          globalFunc.DataValid(this.notice_data.document_title.cn) &&
          !globalFunc.DataValid(this.notice_data.document.cn)
        ) {
          this.snack_bar_text =
            this.$t('error.force_upload') + ' ' + this.$t('general.cn') + ' ' + this.$t('general.document')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (
          !globalFunc.DataValid(this.notice_data.document_title.en) &&
          globalFunc.DataValid(this.notice_data.document.en)
        ) {
          this.snack_bar_text =
            this.$t('error.force_input') +
            ' ' +
            this.$t('general.en') +
            ' ' +
            this.$t('investor_notices.document_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (
          !globalFunc.DataValid(this.notice_data.document_title.cn) &&
          globalFunc.DataValid(this.notice_data.document.cn)
        ) {
          this.snack_bar_text =
            this.$t('error.force_input') +
            ' ' +
            this.$t('general.cn') +
            ' ' +
            this.$t('investor_notices.document_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        try {
          let params = new URLSearchParams()

          params.set('add_investor_notice', JSON.stringify(this.notice_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.create_success')
          this.snack_bar_open = true

          setTimeout(() => {
            this.$router.push({ name: 'InvestorRelationsNotices' })
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.create_fail')
          this.snack_bar_open = true
          this.loading = false
          globalFunc.log(error)
        }
      }
    },
    async updateNotices() {
      if (!this.loading) {
        this.loading = true
        this.notice_data.publish_date = this.select_publish_date

        if (!globalFunc.DataValid(this.notice_data.document_title.zh)) {
          this.snack_bar_text =
            this.$t('error.force_input') +
            ' ' +
            this.$t('general.zh') +
            ' ' +
            this.$t('investor_notices.document_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (!globalFunc.DataValid(this.notice_data.document.zh)) {
          this.snack_bar_text =
            this.$t('error.force_upload') + ' ' + this.$t('general.zh') + ' ' + this.$t('general.document')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (
          globalFunc.DataValid(this.notice_data.document_title.en) &&
          !globalFunc.DataValid(this.notice_data.document.en)
        ) {
          this.snack_bar_text =
            this.$t('error.force_upload') + ' ' + this.$t('general.en') + ' ' + this.$t('general.document')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (
          globalFunc.DataValid(this.notice_data.document_title.cn) &&
          !globalFunc.DataValid(this.notice_data.document.cn)
        ) {
          this.snack_bar_text =
            this.$t('error.force_upload') + ' ' + this.$t('general.cn') + ' ' + this.$t('general.document')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (
          !globalFunc.DataValid(this.notice_data.document_title.en) &&
          globalFunc.DataValid(this.notice_data.document.en)
        ) {
          this.snack_bar_text =
            this.$t('error.force_input') +
            ' ' +
            this.$t('general.en') +
            ' ' +
            this.$t('investor_notices.document_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        if (
          !globalFunc.DataValid(this.notice_data.document_title.cn) &&
          globalFunc.DataValid(this.notice_data.document.cn)
        ) {
          this.snack_bar_text =
            this.$t('error.force_input') +
            ' ' +
            this.$t('general.cn') +
            ' ' +
            this.$t('investor_notices.document_title')
          this.snack_bar_open = true
          this.loading = false
          return
        }

        let send_data = {
          id: this.$route.params.id,
          publish_date: this.notice_data.publish_date,
        }

        send_data['document_title'] = this.notice_data.document_title
        send_data['document'] = this.notice_data.document

        try {
          let params = new URLSearchParams()

          params.set('update_investor_notice', JSON.stringify(send_data))

          let result = await postData(params)
          globalFunc.log(result)

          this.snack_bar_text = this.$t('instruction.update_success')
          this.snack_bar_open = true
          setTimeout(() => {
            location.reload()
          }, 2000)
        } catch (error) {
          this.snack_bar_text = this.$t('instruction.update_fail')
          this.snack_bar_open = true
          this.loading = false
          globalFunc.log(error)
        }
      }
    },
    updateSnackBar(status) {
      this.snack_bar_open = status
    },
  },
  created() {
    if (this.$route.params.id != undefined) {
      this.initializeNotices()
    }
  },
}
</script>
